var _excluded = ["size", "className", "color"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, oneOf } from 'prop-types';
import './SplashAnimation.scss';
import classNames from 'classnames';
var propTypes = {
  /** The size of the splash animation */
  size: oneOf(['small', 'medium', 'large']),

  /** The color of the splash animation */
  color: oneOf(['red', 'white', 'black', 'anthracite']),

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  size: 'medium'
};
/**
 * Splash Animation is a page loader that can be used when loading full pages or applications.
 * @visibleName Splash Animation
 */

var SplashAnimation = function SplashAnimation(_ref) {
  var size = _ref.size,
      className = _ref.className,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClasses = classNames('rds-splash-animation', {
    'rds-splash-animation--small': size === 'small',
    'rds-splash-animation--medium': size === 'medium',
    'rds-splash-animation--large': size === 'large',
    'rds-splash-animation--red': color === 'red',
    'rds-splash-animation--black': color === 'black',
    'rds-splash-animation--anthracite': color === 'anthracite',
    'rds-splash-animation--white': color === 'white'
  }, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: componentClasses
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: "rds-splash-animation__line rds-splash-animation__line--left"
  }), /*#__PURE__*/React.createElement("span", {
    className: "rds-splash-animation__line rds-splash-animation__line--top"
  }), /*#__PURE__*/React.createElement("span", {
    className: "rds-splash-animation__line rds-splash-animation__line--right"
  }), /*#__PURE__*/React.createElement("span", {
    className: "rds-splash-animation__line rds-splash-animation__line--bottom"
  }));
};

SplashAnimation.propTypes = propTypes;
SplashAnimation.defaultProps = defaultProps;
export default SplashAnimation;